import { IStyleManager } from '../checkout/ui/StyleManager';
import { PaymentMethodType } from '../enums/Tokens';
import { IBaseStore } from '../store/BaseStore';
import { Validation } from '../types';
import { ImplementationType } from './payment-method-implementations/types';

// FIXME: Circular dependency
// import { PaymentMethodConfig } from '../core/ClientContextFactory';
// import { IPaymentMethodContext } from '../core/PaymentMethodContext';

export type PaymentMethodSpecs = {
  key: string;
  buttonManagedByPaymentMethod: boolean;
  canVault: boolean;
  hasExportedButtonOptions: boolean;
  homeScene?: string;
  implementationType?: ImplementationType;
};

export class BasePaymentMethod {
  static specs: PaymentMethodSpecs = {
    key: '__none__',
    canVault: false,
    buttonManagedByPaymentMethod: false,
    hasExportedButtonOptions: false,
  };

  readonly type: PaymentMethodType;

  public displayName: string;

  public container: Element | null;

  public remoteConfig: any;

  protected options: Record<string, any> | undefined;

  protected constructor(type: PaymentMethodType, name: string) {
    this.type = type;
    this.displayName = name;
  }

  static create = (
    _context: any,
    _options: Record<string, any>,
    _remoteConfig: any,
    _styleManager?: IStyleManager,
  ): BasePaymentMethod => {
    throw new Error('Cannot instantiate BasePaymentMethod');
  };

  get specs(): PaymentMethodSpecs {
    return (this.constructor as typeof BasePaymentMethod).specs;
  }

  setOption(key, value) {
    if (this.options) {
      this.options[key] = value;
    }
  }

  setupAndValidate(): Promise<boolean> {
    return Promise.resolve(true);
  }

  mount(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tokenize(options?: any): Promise<void> {
    return Promise.resolve();
  }

  validate(): Promise<Validation> {
    return Promise.resolve({ valid: true, validationErrors: [] });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDisabled(disabled: boolean): Promise<void> {
    return Promise.resolve();
  }

  focus(): void {
    return undefined;
  }

  blur(): void {
    return undefined;
  }

  getPaymentElement(): Element | null {
    return null;
  }

  getStore(): IBaseStore | undefined {
    return undefined;
  }
}
